import { gql } from "@apollo/client";

export const FETCH_MEMBERSHIP_DURATION_BY_PACKAGE_ID = gql`
  query FetchMembershipDurationWithPackageId($package_id: UUID!) {
    fetchMembershipDurationWithPackageId(package_id: $package_id) {
      data {
        membership_durations {
          created_at
          description
          duration_type
          id
          number_of_days
          package_id
          price
          updated_at
          price_usd
          package {
            created_at
            description
            id
            name
            package_type
            updated_at
          }
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;
